import { get, post, put } from '@api/request';

export async function fetchWidgets({ appraisalService }, authenticationToken) {
  const url = `${appraisalService}/appraisal/property/widgets`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchWidget(
  { appraisalService },
  authenticationToken,
  { widgetId },
) {
  const url = `${appraisalService}/appraisal/property/widget/${widgetId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateWidget(
  { appraisalService },
  authenticationToken,
  { widgetId, data },
) {
  const url = `${appraisalService}/appraisal/property/widget/${widgetId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function createWidget(
  { appraisalService },
  authenticationToken,
  { data },
) {
  const url = `${appraisalService}/appraisal/property/widgets`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function fetchWidgetInfo(
  { appraisalService },
  authenticationToken,
  { propID, year, version, rollCorrection, widgetId },
) {
  const url = `${appraisalService}/appraisal/property/${propID}/${year}/${version}/${rollCorrection}/${widgetId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateWidgetInfo(
  { appraisalService },
  authenticationToken,
  { propID, year, version, rollCorrection, widgetId, data },
) {
  const url = `${appraisalService}/appraisal/property/${propID}/${year}/${version}/${rollCorrection}/${widgetId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function fetchCodeFiles(
  { appraisalService },
  authenticationToken,
  { name },
) {
  const url = `${appraisalService}/appraisal/codes?type=Property&name=${name}`;
  const { body } = await get(authenticationToken, url);
  return body;
}
